import Header from "../features/marketing/shared/Header.jsx";

export default Header;
